import { useEffect } from "react";
import { Routes, Route } from "react-router-dom";
import Lenis from "lenis";
import "@/App.css";
import { Loader } from "@/components/Loader";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { ScrollToTop } from "@/components/ScrollToTop";
import { SEORouter } from "@/components/seo/SEORouter";
import { GlobalSchema } from "@/components/seo/GlobalSchema";
import Home from "@/pages/Home";
import Products from "@/pages/Products";
import ProductCategory from "@/pages/ProductCategory";
import Configurator from "@/pages/Configurator";
import Projects from "@/pages/Projects";
import Technical from "@/pages/Technical";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import DesignDetail from "@/pages/DesignDetail";
import Finishes from "@/pages/Finishes";
import FAQ from "@/pages/FAQ";
import Terms from "@/pages/Terms";
import OrderStatus from "@/pages/OrderStatus";
import AdminLogin from "@/pages/AdminLogin";
import AdminOrders from "@/pages/AdminOrders";
import Showroom from "@/pages/Showroom";

function App() {
  // Smooth momentum scrolling.
  //
  // iPhone/touch devices: Lenis fights iOS's native inertia and causes jank
  // + rubber-banding artefacts. Disable it on touch-primary devices and let
  // Safari handle scrolling natively. Desktop keeps the Lenis experience.
  useEffect(() => {
    const isTouchPrimary =
      typeof window !== "undefined" &&
      window.matchMedia("(hover: none) and (pointer: coarse)").matches;
    if (isTouchPrimary) return;

    const lenis = new Lenis({
      duration: 1.05,
      easing: (t) => (t === 1 ? 1 : 1 - Math.pow(2, -10 * t)),
      smoothWheel: true,
      wheelMultiplier: 1.25,
      touchMultiplier: 1.6,
      lerp: 0.14,
    });
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
    };
  }, []);

  return (
    <div className="App grain relative">
      {/* SEO: per-route <title>/meta + global Organization/LocalBusiness/WebSite JSON-LD */}
      <SEORouter />
      <GlobalSchema />
      <Loader />
      <ScrollToTop />
      <Navbar />
      <main>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/products" element={<Products />} />
          <Route path="/products/designs" element={<ProductCategory />} />
          <Route path="/products/designs/:modelId" element={<DesignDetail />} />
          <Route path="/products/:slug" element={<Products />} />
          <Route path="/door-configurator" element={<Configurator />} />
          <Route path="/projects" element={<Projects />} />
          <Route path="/technical" element={<Technical />} />
          <Route path="/finishes" element={<Finishes />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/faq" element={<FAQ />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/order-status" element={<OrderStatus />} />
          <Route path="/showroom" element={<Showroom />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin/orders" element={<AdminOrders />} />
          <Route path="*" element={<Home />} />
        </Routes>
      </main>
      <Footer />
    </div>
  );
}

export default App;
